import config from 'crm/config'

const profileApi = `${config.apiHost}/oem-profile`

export default {
    getMoments: {
        url: `${profileApi}/api/moments`,
        type: 'GET',
    },

    createMoment: {
        url: `${profileApi}/api/moments`,
        type: 'POST',
    },

    deleteMoment: {
        url: `${profileApi}/api/moments/{id}`,
        type: 'DELETE',
    },

    getMomentDetails: {
        url: `${profileApi}/api/moments/{id}`,
        type: 'GET',
    },

    editMoment: {
        url: `${profileApi}/api/moments/{id}`,
        type: 'PUT',
    },

    //  获取朋友圈参数
    getMomentsParams: {
        url: `${profileApi}/api/moments/config`,
        type: 'GET',
    },

    // 设置朋友圈参数
    editMomentsParams: {
        url: `${profileApi}/api/moments/config`,
        type: 'POST',
    },
}
